import { Button } from "react-bootstrap";
import { useRouteError } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import { TbFaceIdError } from 'react-icons/tb';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  let navigate = useNavigate(); 

  const routeChange = () => { 
    let path = '/'; 
    navigate(path);
  }

  return (
    <div className="content">
        <Header/>
        <div id="error-page" className="text-center mt-4">
          <div className="mt-4"/>
          <h1 className="text-primary">Oops!</h1>
          <br/>
          <p>Sorry, an unexpected error has occurred.</p>
          <h1 className="text-primary"><TbFaceIdError size={60}/></h1>
          <p>
            <i>{error.statusText || error.message}</i>
          </p>
          <div className="mt-5"/>
          <Button variant="primary" type="button" onClick={routeChange}>Go home</Button>
        </div>
        <Footer/>
    </div>
  );
}